import React from 'react';
import { InputLabel, MenuItem, Select } from '@mui/material';
import { StyledBox } from '../BestCombi.styled';
import { StyledFormControl } from './BCFilterStyled';
import { LiveOrHighlightOrBoth } from '../providerXcompetitonsXgames/types/HighlightOrLiveOrBoth.types';

type BCFilterProps = {
  handleModeChange: (selectedMode: LiveOrHighlightOrBoth) => void;
  mode: LiveOrHighlightOrBoth;
};
const BCFilter: React.FC<BCFilterProps> = ({ handleModeChange, mode }) => {
  return (
    <StyledBox>
      <StyledFormControl>
        <InputLabel id="filter-label">Filter</InputLabel>
        <Select
          labelId="filter-label"
          id="filter"
          value={mode}
          label="Filter"
          onChange={(event) =>
            handleModeChange(event.target.value as LiveOrHighlightOrBoth)
          }
        >
          <MenuItem value="Default" defaultChecked>
            Default
          </MenuItem>
          <MenuItem value="Live">Live streamed</MenuItem>
          <MenuItem value="Highlight">Highlights</MenuItem>
        </Select>
      </StyledFormControl>
    </StyledBox>
  );
};
export default BCFilter;
